import { OctagramEditOutlineIcon } from './OctagramEditOutlineIcon';

/**
 * author: Jeff Anders
 * id 02D856A6-74E6-41EA-8938-054DD39B627D
 * name octagram-edit-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/octagram-edit-outline.svg
 * tags
 * - Shape 
 */
export const StarburstEditOutlineIcon = OctagramEditOutlineIcon;
export default StarburstEditOutlineIcon